/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import {
  Leaf,
  Settings,
  Lightbulb,
  Headset,
  ShieldCheck,
  ArrowRight,
  Droplets,
  Droplet,
  Tractor,
  Wind,
  Star,
  Mail,
  MapPin,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Sprout,
  Home as HomeIcon,
  LineChart,
  Flower2,
  LayoutGrid,
  Search,
  ClipboardCheck,
  Map,
  Wifi,
  Monitor,
  Quote,
  Users,
  LandPlot,
  FlaskConical,
  Share2,
  Satellite,
  CloudRain,
  Bell,
  AlertTriangle,
  CheckCircle2,
  Thermometer,
  Trees,
  BookOpen
} from 'lucide-react';

// Import Assets
import heroSmartAgri from '../assets/hero_smart_agriculture.png';
import dualBackgroundImage from '../assets/dual-background-image.png';
import hero1 from '../assets/hero_image1.jpg';
import hero2 from '../assets/hero_image2.jpeg';
import hero3 from '../assets/hero_image3.jpg';
import hero4 from '../assets/projects/greenhabitat1.PNG';
import agriQImg from '../assets/AgriQ.jpeg';
import vedvanImg from '../assets/vedvan-div.PNG';
import greenhabitatImg from '../assets/greenhabitat-div.png';
import farm360Img from '../assets/Farm360.jpg';
import plantiqImg from '../assets/plantiQ-div.jpeg';
import irriqImg from '../assets/irriQ-div.jpeg';
import organiqImg from '../assets/organiQ-div.jpeg';
import secureImg from '../assets/secure.jpeg';
import proj1 from '../assets/Farm360 project.png';
import proj2 from '../assets/Greenhabitat project.PNG';
import proj3 from '../assets/AgriQ project.png';
import proj4 from '../assets/Vedvan project.PNG';
import smartFarmingImg from '../assets/smart-farming.jpg';
import droneAgriImg from '../assets/quadcopter-flying-nature.jpg';
import vegetableImg from '../assets/vegetable_gardens.jpg';
import isometricFarmImg from '../assets/isometric_smart_farm.png';
import realisticFarmImg from '../assets/realistic_farm.png';
import cropHeatmapImg from '../assets/crop_heatmap.png';
import irrigationImg from '../assets/smart-irrigation.jpg';
import timberImg from '../assets/timber-plantation.jpeg';
import insightImg from '../assets/insight.jpeg';

// Insight Images
import insight1 from '../assets/insights/The Future of Smart Irrigation.png';
import insight2 from '../assets/insights/Why Ecosystem Stewardship.png';
import insight3 from '../assets/insights/Soil Intelligence.png';
// Client Images
import client1 from '../assets/clients/K-RAJAMOHAN-REDDY.png';
import client2 from '../assets/clients/KS-RAO.png';
import client3 from '../assets/clients/Sridevi.png';
import client4 from '../assets/clients/Umamaheshwar-Rao.png';
import client5 from '../assets/clients/Dasari-Srinivasulu-IAS.png';
import client6 from '../assets/clients/A-RAJASEKHAR.png';
import client7 from '../assets/clients/Nityananda-Reddy.png';
import client8 from '../assets/clients/Srinivasa-Rao.png';
import client9 from '../assets/clients/Shaik-Badesaheb.png';
import client10 from '../assets/clients/Srinivasa-reddy.png';
import founder from '../assets/clients/Founder.jpg';

// Partner Logos
import partner1 from '../assets/partners/partner1.jpeg';
import partner2 from '../assets/partners/partner2.png';
import partner3 from '../assets/partners/partner3.PNG';
import partner4 from '../assets/partners/partner4.PNG';
import partner5 from '../assets/partners/partner5.png';
import partner6 from '../assets/partners/partner6.png';
import partner7 from '../assets/partners/partner7.jpeg';
import partner8 from '../assets/partners/partner8.PNG';
import partner9 from '../assets/partners/partner9.jpeg';
import partner10 from '../assets/partners/partner10.jpeg';
import partner11 from '../assets/partners/partner11.png';
import partner12 from '../assets/partners/partner12.PNG';

import banner4 from '../assets/banner-4.png';
import divBg from '../assets/Divisions-bg.webp';
import sustainability from '../assets/Build Smarter Today.png';
import indiamap from '../assets/india_map.webp';
import impactMapImg from '../assets/Impact-india-map.png';
import smarttech from '../assets/smart_tech.webp';
import trusted from '../assets/trust_quality.webp';
import support from '../assets/support.webp'
import oneland from '../assets/images/realistic_smart_agriculture.png'

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const testimonialsRef = useRef(null);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [canScrollTestiLeft, setCanScrollTestiLeft] = useState(false);
  const [canScrollTestiRight, setCanScrollTestiRight] = useState(true);

  const handleTestimonialScroll = () => {
    if (testimonialsRef.current) {
      const scrollPosition = testimonialsRef.current.scrollLeft;
      const scrollWidth = testimonialsRef.current.scrollWidth;
      const clientWidth = testimonialsRef.current.clientWidth;
      
      setCanScrollTestiLeft(scrollPosition > 0);
      setCanScrollTestiRight(Math.ceil(scrollPosition + clientWidth) < scrollWidth);

      const card = testimonialsRef.current.children[0];
      if (card) {
        const cardWidth = card.offsetWidth + 24; // card width + gap-6 (24px)
        const index = Math.round(scrollPosition / cardWidth);
        setActiveTestimonial(index);
      }
    }
  };

  const scrollTestimonialDir = (dir) => {
    if (testimonialsRef.current) {
      const card = testimonialsRef.current.children[0];
      if (card) {
        const scrollAmount = card.offsetWidth + 24;
        testimonialsRef.current.scrollBy({
          left: dir === 'next' ? scrollAmount : -scrollAmount,
          behavior: 'smooth'
        });
      }
    }
  };

  const scrollToTestimonial = (index) => {
    if (testimonialsRef.current) {
      const card = testimonialsRef.current.children[0];
      if (card) {
        const cardWidth = card.offsetWidth + 24;
        testimonialsRef.current.scrollTo({
          left: cardWidth * index,
          behavior: 'smooth'
        });
      }
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll, .animate-on-scroll-left, .animate-on-scroll-right, .animate-on-scroll-zoom').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const slides = [
    { img: hero1, alt: "Agricultural ecosystem" },
    { img: hero2, alt: "Precision farming and smart tech" },
    { img: hero3, alt: "Agroforestry and land performance" },
    { img: hero4, alt: "Sustainable landscape and ecosystem transformation" }
  ];

  const partners = [
    { img: partner1, alt: "Tata Solar logo" },
    { img: partner2, alt: "Department of Agriculture logo" },
    { img: partner3, alt: "Netafim logo" },
    { img: partner4, alt: "Finolex Pipes logo" },
    { img: partner5, alt: "Cropin Cloud logo" },
    { img: partner6, alt: "ICAR–Indian Agricultural Research Institute (IARI) logo" },
    { img: partner7, alt: "Farmonaut logo" },
    { img: partner8, alt: "Sheel Biotech Limited logo" },
    { img: partner9, alt: "CADAgro logo" },
    { img: partner10, alt: "National Horticulture Board logo" },
    { img: partner11, alt: "Jain Hi-Tech Plant Factory logo" },
    { img: partner12, alt: "Hikvision logo" }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    const observerOptions = { threshold: 0.1 };
    const observer = new IntersectionObserver((entries) => {      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          // Optional: remove visible class when scrolling up if you want repeatable animations
          entry.target.classList.remove('visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.animate-on-scroll, .animate-on-scroll-left, .animate-on-scroll-right').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative min-h-[90vh] md:min-h-screen bg-[#0a1a0d] flex items-center pt-24 pb-48 md:pb-32">
        {/* Background Image Container with overflow hidden */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <div
            className={`absolute inset-0 bg-cover bg-center transition-transform duration-[10000ms] ease-out ${isMounted ? 'scale-105' : 'scale-100'}`}
            style={{ backgroundImage: `url('${heroSmartAgri}')` }}
          >
            {/* Gradient Overlay for better readability */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a0d]/90 via-transparent to-transparent"></div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto w-full relative z-10 px-6 lg:px-12 flex flex-col justify-center h-full mt-16 lg:mt-26">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            
            {/* Left Content */}
            <div className="lg:col-span-8 xl:col-span-8 flex flex-col items-start text-white">
              <div className="animate-on-scroll delay-100 mb-6 inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-black/20 backdrop-blur-sm border border-[#2d7a26] text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-white shadow-lg">
                <Leaf className="w-3.5 h-3.5 text-white" />
                AGRICULTURE TECHNOLOGY & LAND ECOSYSTEMS
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] mb-6 font-extrabold leading-[1.1] whitespace-nowrap flex flex-col gap-1 overflow-hidden">
                <div className="animate-on-scroll-left delay-200 text-white">Transforming Land Through</div>
                <div className="animate-on-scroll-right delay-200 text-primary-green">Science, Technology &</div>
                <div className="animate-on-scroll-left delay-200 text-primary-green">Stewardship</div>
              </h1>
              
              <p className="text-sm md:text-base lg:text-[17px] mb-8 opacity-95 max-w-xl lg:max-w-[750px] animate-on-scroll delay-300 font-medium leading-[1.6] drop-shadow-md text-gray-100">
                We assess, develop, automate and manage productive agricultural ecosystems <br className="hidden lg:block" />
                for landowners, enterprises and institutions.
              </p>

              {/* Grid of features */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-4 mb-10 w-full max-w-[700px] animate-on-scroll delay-400">
                <div className="flex items-center gap-2.5">
                  <div className="w-10 h-10 rounded-full border border-white/40 flex items-center justify-center shrink-0">
                    <Leaf className="w-4 h-4 text-white opacity-95" />
                  </div>
                  <span className="text-[11px] md:text-xs font-bold leading-[1.3] tracking-wide">Higher <br/>Productivity</span>
                </div>
                <div className="flex items-center gap-2.5">
                  <div className="w-10 h-10 rounded-full border border-white/40 flex items-center justify-center shrink-0">
                    <Droplets className="w-4 h-4 text-white opacity-95" />
                  </div>
                  <span className="text-[11px] md:text-xs font-bold leading-[1.3] tracking-wide">Smart Water <br/>Management</span>
                </div>
                <div className="flex items-center gap-2.5">
                  <div className="w-10 h-10 rounded-full border border-white/40 flex items-center justify-center shrink-0">
                    <ShieldCheck className="w-4 h-4 text-white opacity-95" />
                  </div>
                  <span className="text-[11px] md:text-xs font-bold leading-[1.3] tracking-wide">Healthy <br/>Ecosystems</span>
                </div>
                <div className="flex items-center gap-2.5">
                  <div className="w-10 h-10 rounded-full border border-white/40 flex items-center justify-center shrink-0">
                    <LineChart className="w-4 h-4 text-white opacity-95" />
                  </div>
                  <span className="text-[11px] md:text-xs font-bold leading-[1.3] tracking-wide">Long-Term <br/>Value</span>
                </div>
              </div>

              {/* Actions */}
              <div className="animate-on-scroll delay-500 flex flex-col sm:flex-row gap-4 mb-6 w-full sm:w-auto">
                <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-[#2d7a26] hover:bg-[#1f5c18] text-white rounded-full font-bold text-sm transition-all duration-300 shadow-xl w-full sm:w-auto group">
                  <Leaf className="w-4 h-4" />
                  Request Land Assessment
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
                <Link to="/solutions" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent hover:bg-white/10 border border-white/70 text-white rounded-full font-bold text-sm transition-all duration-300 w-full sm:w-auto group">
                  Explore Our Solutions
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>

            </div>

            {/* Right Content - Floating Cards */}
            <div className="hidden lg:flex lg:col-span-4 xl:col-span-4 justify-end relative items-center">
              <div className="relative flex flex-col gap-4 animate-on-scroll delay-500 w-full max-w-[280px]">
                {/* Connecting Vertical Line */}
                <div className="absolute left-1/2 top-4 bottom-4 w-[1px] bg-white/30 -translate-x-1/2 z-0"></div>

                {/* Card 1 */}
                <div className="relative z-10 bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl p-4 flex items-center gap-4 shadow-2xl hover:-translate-y-1 transition-transform w-full">
                  <div className="flex items-center justify-center shrink-0 w-10">
                    <Droplet className="w-8 h-8 text-[#A4D738] stroke-[1.5]" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white font-semibold text-[13px] mb-0.5">Soil Moisture</p>
                    <p className="text-[#A4D738] font-medium text-base">Optimal</p>
                  </div>
                  <div className="flex items-end gap-1 h-6">
                    <div className="w-1 bg-white h-3 rounded-full animate-level" style={{ animationDelay: '0ms' }}></div>
                    <div className="w-1 bg-white h-4 rounded-full animate-level" style={{ animationDelay: '300ms' }}></div>
                    <div className="w-1 bg-white h-5 rounded-full animate-level" style={{ animationDelay: '600ms' }}></div>
                    <div className="w-1 bg-white h-6 rounded-full animate-level" style={{ animationDelay: '900ms' }}></div>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="relative z-10 bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl p-4 flex items-center gap-4 shadow-2xl hover:-translate-y-1 transition-transform w-full">
                  <div className="flex items-center justify-center shrink-0 w-10">
                    <Wind className="w-8 h-8 text-white stroke-[1.5]" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white font-semibold text-[13px] mb-0.5">Irrigation</p>
                    <p className="text-white font-medium text-base">Active</p>
                  </div>
                  <div className="flex items-end gap-1 h-6">
                    <div className="w-1 bg-white h-4 rounded-full animate-level" style={{ animationDelay: '200ms' }}></div>
                    <div className="w-1 bg-white/60 h-3 rounded-full animate-level" style={{ animationDelay: '500ms' }}></div>
                    <div className="w-1 bg-white h-5 rounded-full animate-level" style={{ animationDelay: '800ms' }}></div>
                    <div className="w-1 bg-white/80 h-6 rounded-full animate-level" style={{ animationDelay: '1100ms' }}></div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="relative z-10 bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl p-4 flex items-center gap-4 shadow-2xl hover:-translate-y-1 transition-transform w-full">
                  <div className="flex items-center justify-center shrink-0 w-10">
                    <Leaf className="w-8 h-8 text-white stroke-[1.5]" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white font-semibold text-[13px] mb-0.5">Crop Health</p>
                    <p className="text-white font-medium text-base">Excellent</p>
                  </div>
                  <div className="flex items-end gap-1 h-6">
                    <div className="w-1 bg-white/40 h-3 rounded-full animate-level" style={{ animationDelay: '400ms' }}></div>
                    <div className="w-1 bg-white/60 h-4 rounded-full animate-level" style={{ animationDelay: '700ms' }}></div>
                    <div className="w-1 bg-white/80 h-5 rounded-full animate-level" style={{ animationDelay: '100ms' }}></div>
                    <div className="w-1 bg-white h-6 rounded-full animate-level" style={{ animationDelay: '1000ms' }}></div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        {/* Stats Bar at the bottom of hero */}
        <div className="absolute bottom-0 translate-y-1/2 left-0 w-full z-30 px-4 md:px-6 lg:px-12">
          <div className="mx-auto w-full max-w-7xl bg-white rounded-2xl lg:rounded-[2rem] shadow-2xl overflow-hidden">
            <div className="w-full overflow-x-auto scrollbar-hide">
              <div className="py-6 md:py-8 px-4 md:px-8 grid grid-cols-2 md:grid-cols-3 lg:flex lg:items-center lg:justify-between min-w-max lg:min-w-0 gap-y-8 lg:gap-y-0 gap-x-6 lg:gap-x-6 lg:divide-x divide-gray-200">
                
                {/* Item 1 */}
                <div className="flex items-center gap-3 lg:gap-4 lg:px-4 lg:pl-0 min-w-0 lg:flex-1">
                  <Sprout className="w-8 h-8 lg:w-10 lg:h-10 text-[#2d7a26] shrink-0" strokeWidth={1.5} />
                  <div>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-black text-[#1a1a1a] whitespace-nowrap">20+</h4>
                    <p className="text-[9px] sm:text-[10px] md:text-[11px] font-medium text-[#666] uppercase tracking-wide whitespace-nowrap">Years of Experience</p>
                  </div>
                </div>
                
                {/* Item 2 */}
                <div className="flex items-center gap-3 lg:gap-4 lg:px-4 min-w-0 lg:flex-1">
                  <Users className="w-8 h-8 lg:w-10 lg:h-10 text-[#2d7a26] shrink-0" strokeWidth={1.5} />
                  <div>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-black text-[#1a1a1a] whitespace-nowrap">2,500+</h4>
                    <p className="text-[9px] sm:text-[10px] md:text-[11px] font-medium text-[#666] uppercase tracking-wide whitespace-nowrap">Customers Served</p>
                  </div>
                </div>
                
                {/* Item 3 */}
                <div className="flex items-center gap-3 lg:gap-4 lg:px-4 min-w-0 lg:flex-1">
                  <LandPlot className="w-8 h-8 lg:w-10 lg:h-10 text-[#2d7a26] shrink-0" strokeWidth={1.5} />
                  <div>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-black text-[#1a1a1a] whitespace-nowrap">1,00,000+</h4>
                    <p className="text-[9px] sm:text-[10px] md:text-[11px] font-medium text-[#666] uppercase tracking-wide whitespace-nowrap">Acres Assessed</p>
                  </div>
                </div>
                
                {/* Item 4 */}
                <div className="flex items-center gap-3 lg:gap-4 lg:px-4 min-w-0 lg:flex-1">
                  <div 
                    className="w-8 h-8 lg:w-10 lg:h-10 bg-[#2d7a26] shrink-0" 
                    style={{
                      maskImage: `url(${indiamap})`,
                      WebkitMaskImage: `url(${indiamap})`,
                      maskSize: 'contain',
                      WebkitMaskSize: 'contain',
                      maskRepeat: 'no-repeat',
                      WebkitMaskRepeat: 'no-repeat',
                      maskPosition: 'center',
                      WebkitMaskPosition: 'center',
                    }} 
                  />
                  <div>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-black text-[#1a1a1a] whitespace-nowrap">Multi-State</h4>
                    <p className="text-[9px] sm:text-[10px] md:text-[11px] font-medium text-[#666] uppercase tracking-wide whitespace-nowrap">Operations</p>
                  </div>
                </div>
                
                {/* Item 5 */}
                <div className="flex items-center justify-center md:justify-start col-span-2 md:col-span-1 gap-3 lg:gap-4 lg:px-4 lg:pr-0 min-w-0 lg:flex-1">
                  <ShieldCheck className="w-8 h-8 lg:w-10 lg:h-10 text-[#2d7a26] shrink-0" strokeWidth={1.5} />
                  <div>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-black text-[#1a1a1a] whitespace-nowrap">A VBR</h4>
                    <p className="text-[9px] sm:text-[10px] md:text-[11px] font-medium text-[#666] uppercase tracking-wide whitespace-nowrap">Group Company</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <button 
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
          className="absolute bottom-20 md:bottom-24 left-0 w-full z-10 flex flex-col items-center animate-bounce hover:opacity-80 transition-opacity cursor-pointer"
        >
          <div className="w-5 h-8 rounded-full border border-white/50 flex justify-center p-1 mb-1">
            <div className="w-1 h-2 bg-white rounded-full animate-pulse"></div>
          </div>
          <div className="flex flex-col items-center gap-0">
            <span className="text-[9px] text-white/80 font-medium tracking-widest uppercase ml-[0.1em]">Scroll to Explore</span>
            <ChevronDown className="w-3 h-3 text-white/50" />
          </div>
        </button>
      </section>

      {/* Dual Background Story Section */}
      <section className="relative flex flex-col pt-32 sm:pt-36 lg:pt-24 pb-12 w-full bg-[#f8f9fa] border-b border-gray-100">
        {/* Unified Background */}
        <div className="absolute inset-0 z-0 bg-cover bg-center overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${dualBackgroundImage})` }}></div>
        </div>

        {/* Center Gradient Overlay */}
        <div className="absolute inset-0 z-10 pointer-events-none flex justify-center items-center">
           <div className="w-full max-w-[1200px] h-full bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.85)_0%,_rgba(255,255,255,0.7)_25%,_rgba(255,255,255,0)_60%)] md:bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.85)_0%,_rgba(255,255,255,0.6)_25%,_rgba(255,255,255,0)_55%)]"></div>
        </div>

        {/* Content */}
        <div className="relative z-20 max-w-4xl mx-auto text-center px-6 mt-8 md:mt-12 flex flex-col items-center">
          <h2 className="text-4xl md:text-[3.5rem] font-bold text-[#1a2d1a] leading-[1.15] mb-8 animate-on-scroll">
            Every Land Has A Story. <br />
            <span className="text-primary-green">We Help Write Its Future.</span>
          </h2>
          
          <div className="flex items-center justify-center gap-4 w-full mb-5 opacity-60 animate-on-scroll delay-100">
            <div className="h-[1.5px] w-16 bg-gray-400"></div>
            <Leaf className="w-6 h-6 text-gray-500" strokeWidth={1.5} />
            <div className="h-[1.5px] w-16 bg-gray-400"></div>
          </div>
          
          <p className="text-[#20311f] font-medium text-[17px] md:text-lg leading-relaxed max-w-2xl mx-auto mb-12 animate-on-scroll delay-200">
            Every successful agricultural project begins with understanding the land—not assumptions. Our multidisciplinary approach combines science, technology and execution to unlock long-term value.
          </p>
          
          <button 
            onClick={() => { const el = document.getElementById('process-panel'); if(el) el.scrollIntoView({ behavior: 'smooth' }); }}
            className="bg-[#2d7a26] text-white px-8 py-3.5 rounded-full font-bold hover:bg-[#205c1c] transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl hover:-translate-y-1 animate-on-scroll delay-300"
          >
            Explore Our Process
            <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center shrink-0">
              <ArrowRight className="w-3.5 h-3.5 text-[#2d7a26] font-bold" />
            </div>
          </button>
        </div>

        {/* Process Panel */}
        <div id="process-panel" className="relative z-30 w-[95%] max-w-6xl mx-auto -mb-32 mt-16 animate-on-scroll delay-500">
          <div className="bg-white rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.08)] overflow-hidden">
            <div className="w-full overflow-x-auto scrollbar-hide py-6 md:py-8 px-6 md:px-10">
              <div className="relative flex items-start justify-between min-w-[800px] lg:min-w-0 pt-2">
              {[
                { icon: LayoutGrid, label: '1. LAND' },
                { icon: Search, label: '2. UNDERSTAND' },
                { icon: ClipboardCheck, label: '3. PLAN' },
                { icon: Map, label: '4. DESIGN' },
                { icon: Tractor, label: '5. BUILD' },
                { icon: Wifi, label: '6. AUTOMATE' },
                { icon: Monitor, label: '7. MANAGE' },
                { icon: Sprout, label: '8. GROW' },
              ].map((step, idx) => (
                <React.Fragment key={idx}>
                  <div className="flex flex-col items-center gap-4 group cursor-pointer w-24 shrink-0 z-10">
                    <div className="w-16 h-16 rounded-full bg-white shadow-[0_4px_20px_rgba(0,0,0,0.06)] flex items-center justify-center shrink-0 group-hover:bg-[#2d7a26] group-hover:shadow-[0_8px_25px_rgba(0,0,0,0.15)] group-hover:-translate-y-1 transition-all duration-300">
                      <step.icon className="w-7 h-7 text-[#2d7a26] group-hover:text-white group-hover:scale-110 transition-all duration-300" strokeWidth={1.5} />
                    </div>
                    <span className="text-[11px] font-bold text-[#1e3919] tracking-widest text-center whitespace-nowrap">{step.label}</span>
                  </div>
                  {idx < 7 && (
                    <div className="text-[#3b5938] shrink-0 mt-[2rem] z-10 bg-white px-1">
                      <ArrowRight className="w-[14px] h-[14px]" strokeWidth={3} />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

        {/* Bottom Decorative Ground (Moved to next section padding) */}
      </section>

      {/* Methodology Section - Dark Theme 3-Column */}
      <section className="relative w-full bg-[#050A05] py-32 overflow-hidden">
        {/* Background glow effects */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#2d7a26]/10 rounded-full blur-[100px] -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#1e3919]/20 rounded-full blur-[120px] translate-x-1/3 translate-y-1/3"></div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-12 lg:gap-8 max-w-[1400px] mx-auto w-full px-6 relative z-10">
          
          {/* Column 1: Left Context */}
          <div className="flex flex-col gap-6 pt-12 animate-on-scroll">
         
            <h2 className="text-4xl lg:text-[2.75rem] font-bold text-white leading-[1.2] tracking-tight">
              One Integrated <br/>Methodology.<br/>
              <span className="text-[#2d7a26]">Endless Possibilities.</span>
            </h2>
            
            <div className="h-[1px] w-12 bg-[#2d7a26]/50 mt-4"></div>
            
            <p className="text-gray-300 font-medium text-base lg:text-lg leading-relaxed mt-2 max-w-md">
              Every land is different.<br/>
              That's why every Kisan project begins<br/>
              with science, follows engineering<br/>
              and ends with long-term stewardship.
            </p>
            
            {/* The Kisan Ecosystem Method Card */}
            <div className="mt-auto pt-12">
              <div className="border border-[#2d7a26]/30 rounded-2xl p-6 lg:p-8 bg-[#0a150a]/80 backdrop-blur-sm relative overflow-hidden group hover:border-[#2d7a26]/60 transition-colors duration-500 shadow-2xl shadow-black/50">
                <div className="absolute top-0 left-0 w-1/2 h-[1px] bg-gradient-to-r from-[#2d7a26] to-transparent opacity-50 group-hover:opacity-100 transition-opacity"></div>
                <div className="absolute top-0 left-0 h-1/2 w-[1px] bg-gradient-to-b from-[#2d7a26] to-transparent opacity-50 group-hover:opacity-100 transition-opacity"></div>
                
                <h3 className="text-[#2d7a26] font-semibold text-lg lg:text-xl mb-8">The Kisan Ecosystem Method™</h3>
                <div className="flex flex-col gap-6">
                  {/* Features */}
                  <div className="flex gap-4 items-start">
                    <div className="w-8 h-8 shrink-0 flex items-center justify-center text-[#2d7a26]">
                      <FlaskConical className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h4 className="text-white font-semibold text-sm lg:text-base">Science-Based Decisions</h4>
                      <p className="text-gray-400 text-[11px] lg:text-xs mt-1">Research, data & field intelligence</p>
                    </div>
                  </div>
                  <div className="flex gap-4 items-start">
                    <div className="w-8 h-8 shrink-0 flex items-center justify-center text-[#2d7a26]">
                      <Share2 className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h4 className="text-white font-semibold text-sm lg:text-base">Integrated Expertise</h4>
                      <p className="text-gray-400 text-[11px] lg:text-xs mt-1">Agronomy, engineering, technology & management</p>
                    </div>
                  </div>
                  <div className="flex gap-4 items-start">
                    <div className="w-8 h-8 shrink-0 flex items-center justify-center text-[#2d7a26]">
                      <ShieldCheck className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h4 className="text-white font-semibold text-sm lg:text-base">End-to-End Ownership</h4>
                      <p className="text-gray-400 text-[11px] lg:text-xs mt-1">From planning to long-term stewardship</p>
                    </div>
                  </div>
                  <div className="flex gap-4 items-start">
                    <div className="w-8 h-8 shrink-0 flex items-center justify-center text-[#2d7a26]">
                      <Leaf className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h4 className="text-white font-semibold text-sm lg:text-base">Sustainable Impact</h4>
                      <p className="text-gray-400 text-[11px] lg:text-xs mt-1">Productive today. Regenerative tomorrow.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Center Winding Timeline */}
          <div className="relative w-[320px] py-12 mx-auto h-[900px]">
            {/* The CSS Curve Graphic */}
            <div className="absolute inset-0 pointer-events-none animate-on-scroll delay-100">
              {/* Main dashed line */}
              <svg viewBox="0 0 320 900" className="w-full h-full opacity-60" preserveAspectRatio="none">
                <path 
                  d="M 252,28 C 252,88 68,88 68,149 C 68,210 252,210 252,270 C 252,330 68,330 68,391 C 68,451 252,451 252,512 C 252,572 68,572 68,632 C 68,693 252,693 252,753 C 252,813 68,813 68,872" 
                  fill="none" 
                  stroke="#2d7a26" 
                  strokeWidth="2" 
                  strokeDasharray="6 8"
                  className="drop-shadow-[0_0_8px_rgba(45,122,38,0.4)]"
                />
              </svg>
            </div>
            
            {/* The Steps */}
            <div className="absolute inset-0 z-10 w-full h-full">
              {[
                { icon: MapPin, label: 'LAND', desc: 'Every journey begins with the land.' },
                { icon: Search, label: 'ASSESS', desc: 'On-ground surveys, soil, water & climate analysis.' },
                { icon: LineChart, label: 'ANALYZE', desc: 'Data, GIS & advanced modelling for insights.' },
                { icon: Map, label: 'DESIGN', desc: 'Custom masterplan for crops, infrastructure & more.' },
                { icon: Tractor, label: 'DEVELOP', desc: 'Precision execution with quality & sustainability.' },
                { icon: Wifi, label: 'AUTOMATE', desc: 'Smart irrigation, fertigation & climate control systems.' },
                { icon: Monitor, label: 'MONITOR', desc: 'Real-time monitoring using IoT, drones & satellite.' },
                { icon: Users, label: 'MANAGE', desc: 'Expert management for higher productivity & lasting value.' },
              ].map((step, idx) => {
                const isRight = idx % 2 === 0;
                // Calculate precise top position based on item index to match SVG points
                // 8 items, equally spaced in 900px container
                const yPos = 28 + (idx * 120.57); 
                
                return (
                  <div 
                    key={idx} 
                    className={`absolute flex items-center gap-5 animate-on-scroll group`}
                    style={{
                      top: `${yPos}px`,
                      left: isRight ? '0px' : '40px',
                      right: isRight ? '40px' : '0px',
                      flexDirection: isRight ? 'row-reverse' : 'row',
                      transform: `translateY(-50%)`,
                      animationDelay: `${idx * 150}ms`
                    }}
                  >
                    {/* Icon Node */}
                    <div className="relative w-14 h-14 rounded-full border-[1.5px] border-[#2d7a26]/30 bg-[#0a150a] flex items-center justify-center shrink-0 group-hover:bg-[#2d7a26]/5 transition-colors cursor-pointer shadow-[0_0_20px_rgba(45,122,38,0.15)] group-hover:shadow-[0_0_30px_rgba(45,122,38,0.4)] z-20">
                      <step.icon className="w-5 h-5 text-[#2d7a26]" strokeWidth={1.5} />
                    </div>
                    {/* Label */}
                    <div className={`flex flex-col ${isRight ? 'text-right' : 'text-left'}`}>
                      <h4 className={`text-white font-black text-base tracking-widest uppercase flex items-center gap-2 ${isRight ? 'justify-end' : 'justify-start'}`}>
                        {isRight ? <>{step.label} <span className="text-[#2d7a26]">0{idx+1}</span></> : <><span className="text-[#2d7a26]">0{idx+1}</span> {step.label}</>}
                      </h4>
                      <p className="text-gray-400 text-[10px] mt-1.5 leading-snug max-w-[160px]">{step.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Column 3: Right Context (Images & Quote) */}
          <div className="flex flex-col gap-4 lg:pt-0 h-full animate-on-scroll delay-200">
            {/* Main Image */}
            <div className="w-full h-[320px] lg:h-[420px] rounded-[2rem] rounded-tl-xl overflow-hidden relative shadow-2xl border border-gray-800">
              <img src={heroSmartAgri} className="w-full h-full object-cover" alt="Kisan Plant Methodology" />
              {/* Internal overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            
            {/* Thumbnails Grid */}
            <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 w-full mt-2">
              {[
                { img: insightImg, label: 'Survey' },
                { img: smartFarmingImg, label: 'Analysis' },
                { img: irrigationImg, label: 'Design' },
                { img: timberImg, label: 'Development' },
                { img: droneAgriImg, label: 'Monitoring' },
                { img: vegetableImg, label: 'Management' }
              ].map((thumb, idx) => (
                <div key={idx} className="flex flex-col items-center gap-1.5 group cursor-pointer">
                  <div className="aspect-square w-full rounded-xl overflow-hidden bg-gray-900 border border-gray-800 relative">
                    <img src={thumb.img} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500" alt={thumb.label} />
                  </div>
                  <span className="text-[9px] text-gray-400 font-medium tracking-wide group-hover:text-white transition-colors">{thumb.label}</span>
                </div>
              ))}
            </div>
            
            {/* Quote Block */}
            <div className="mt-auto bg-[#0a150a]/90 border border-gray-800 rounded-3xl p-6 lg:p-8 relative mt-8 lg:mt-6 overflow-hidden">
              <Quote className="absolute top-4 left-4 w-12 h-12 text-[#2d7a26] opacity-10" />
              <p className="text-gray-200 text-lg lg:text-xl font-medium pl-10 leading-snug">
                Great farms are not built in one season.<br/>
                <span className="text-[#2d7a26]">They are built through systems.</span>
              </p>
            </div>
          </div>

        </div>
        
        {/* Decorative Scroll Down Indicator */}
        <button onClick={() => window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' })} className="hidden lg:flex absolute bottom-8 left-0 right-0 mx-auto w-max flex-col items-center gap-3 animate-bounce">
          <div className="w-[1px] h-12 bg-gradient-to-b from-[#2d7a26] to-transparent"></div>
          <span className="text-[9px] text-[#2d7a26] font-medium tracking-widest uppercase ml-[0.1em]">Scroll to Explore</span>
        </button>
      </section>

      {/* SCENE 4: Data to Decisions Section */}
      <section className="relative bg-[#f8f9fa] text-[#1a2d1a] py-20 lg:py-20 overflow-hidden font-sans">
        {/* Background glows */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#2d7a26] blur-[120px] rounded-full opacity-10 pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-full h-[300px] bg-gradient-to-t from-[#2d7a26]/10 to-transparent pointer-events-none"></div>

        <div className="relative z-10 max-w-[1400px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          
          {/* Left Column: Heading and Timeline Steps */}
          <div className="lg:col-span-4 flex flex-col gap-12">
            <div className="animate-on-scroll-left">
           
              <h2 className="text-4xl lg:text-5xl font-extrabold leading-[1.1] tracking-tight mb-6 text-[#1a2d1a]">
                Every Acre Has Data.<br />
                <span className="text-[#2d7a26]">We Turn It Into Decisions.</span>
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed max-w-sm">
                Satellite intelligence, GIS, soil analytics, sensors, automation and field expertise—combined into one connected decision system.
              </p>
            </div>

            {/* Timeline Steps */}
            <div className="flex flex-col gap-4 relative py-4">
              {/* Vertical Line */}
              <div className="absolute left-[19px] top-10 bottom-10 w-[2px] bg-gray-200 z-0 animate-on-scroll delay-[100ms]"></div>

              {[
                { num: "01", title: "OBSERVE", desc: "Satellite, drone and field surveys", icon: Satellite, delay: "delay-[200ms]" },
                { num: "02", title: "UNDERSTAND", desc: "Soil, water, climate and crop analytics", icon: FlaskConical, delay: "delay-[300ms]" },
                { num: "03", title: "DECIDE", desc: "GIS, models and expert recommendations", icon: LineChart, delay: "delay-[400ms]" },
                { num: "04", title: "ACT", desc: "Automation, irrigation and farm operations", icon: Tractor, delay: "delay-[500ms]" }
              ].map((step, idx) => (
                <div key={idx} className={`relative flex items-center gap-4 z-10 group animate-on-scroll-left ${step.delay}`}>
                  
                  {/* The Dot */}
                  <div className="w-10 flex justify-center shrink-0">
                    <div className="w-3 h-3 bg-[#2d7a26] rounded-full shadow-[0_0_10px_rgba(45,122,38,0.4)] ring-4 ring-[#f8f9fa]"></div>
                  </div>

                  {/* Card Content */}
                  <div className="flex-1 bg-white border border-gray-100 shadow-[0_4px_20px_rgb(0,0,0,0.03)] rounded-3xl p-4 md:p-5 flex items-center gap-5 transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                    <div className="w-14 h-14 rounded-full flex items-center justify-center shrink-0 border border-[#2d7a26]/30 bg-[#2d7a26]/5 text-[#2d7a26]">
                      <step.icon className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="flex items-center gap-3 mb-1">
                        <span className="text-sm font-extrabold text-[#2d7a26]">{step.num}</span>
                        <h4 className="text-[15px] font-extrabold tracking-widest uppercase text-[#1a2d1a]">{step.title}</h4>
                      </div>
                      <p className="text-[13px] text-gray-500 font-medium">{step.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Center Column: Farm Graphic and Quote */}
          <div className="lg:col-span-5 flex flex-col items-center justify-center py-12 lg:py-0 text-center relative">
            <div className="w-full max-w-[500px] aspect-square relative mb-8 flex items-center justify-center animate-on-scroll-zoom delay-[200ms]">
              <img src={realisticFarmImg} alt="Realistic Farm Aerial View" className="w-full h-full object-cover rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.15)] z-10 relative" />
              
              {/* Floating Widget: Soil Zones */}
              <div className="absolute left-[-1rem] lg:left-[-3rem] top-1/2 -translate-y-1/2 bg-white border border-gray-200 shadow-xl rounded-xl p-3 z-20 text-left w-32 animate-[bounce_5s_infinite]">
                <h5 className="text-[9px] font-bold tracking-widest text-[#2d7a26] uppercase mb-2">SOIL ZONES</h5>
                <div className="flex flex-col gap-1.5">
                  <div className="flex items-center gap-2"><div className="w-2 h-2 rounded-full bg-[#84cc16]"></div><span className="text-[9px] text-[#1a2d1a] font-bold">Clay Loam</span></div>
                  <div className="flex items-center gap-2"><div className="w-2 h-2 rounded-full bg-yellow-500"></div><span className="text-[9px] text-[#1a2d1a] font-bold">Sandy Loam</span></div>
                  <div className="flex items-center gap-2"><div className="w-2 h-2 rounded-full bg-blue-500"></div><span className="text-[9px] text-[#1a2d1a] font-bold">Silt Loam</span></div>
                  <div className="flex items-center gap-2"><div className="w-2 h-2 rounded-full bg-orange-500"></div><span className="text-[9px] text-[#1a2d1a] font-bold">Clay</span></div>
                </div>
              </div>

              {/* Floating Widget: Digital Twin */}
              <div className="absolute right-[-1rem] lg:right-[-2rem] top-[15%] bg-white border border-gray-200 shadow-xl rounded-xl p-3 z-20 text-left w-32 animate-[bounce_6s_infinite_reverse]">
                <h5 className="text-[9px] font-bold tracking-widest text-[#2d7a26] uppercase mb-1">DIGITAL TWIN</h5>
                <p className="text-[9px] text-gray-500 leading-tight font-medium">Real-time insights.<br/>Smarter decisions.</p>
              </div>

              {/* Floating Widget: Irrigation Plan */}
              <div className="absolute right-0 lg:right-[-1rem] bottom-[20%] bg-white border border-gray-200 shadow-xl rounded-xl p-3 z-20 text-left w-32 animate-[bounce_4s_infinite]">
                <h5 className="text-[9px] font-bold tracking-widest text-[#2d7a26] uppercase mb-2">IRRIGATION PLAN</h5>
                <div className="flex flex-col gap-1.5">
                  <div className="flex items-center gap-2"><div className="w-3 h-0.5 bg-blue-500"></div><span className="text-[9px] text-[#1a2d1a] font-bold">Drip Lines</span></div>
                  <div className="flex items-center gap-2"><div className="w-3 h-0.5 bg-[#84cc16]"></div><span className="text-[9px] text-[#1a2d1a] font-bold">Main Lines</span></div>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col items-center animate-on-scroll delay-[400ms]">
              <Quote className="w-8 h-8 text-[#2d7a26] mb-4 opacity-50 rotate-180" />
              <p className="text-xl lg:text-2xl text-[#1a2d1a] font-medium mb-8">
                Data alone changes nothing.<br />
                <span className="text-[#2d7a26] font-bold">Decisions do.</span>
              </p>
              <Link to="/technology" className="bg-white border border-[#2d7a26] text-[#2d7a26] px-8 py-3 rounded-full font-bold hover:bg-[#2d7a26] hover:text-white transition-all duration-300 flex items-center gap-3 group shadow-lg hover:shadow-xl hover:-translate-y-1">
                Explore Kisan Technology
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>

          {/* Right Column: Dashboard Widgets */}
          <div className="lg:col-span-3 flex flex-col gap-4">
            
            {/* Widget 1: Live Dashboard */}
            <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 rounded-2xl p-5 animate-on-scroll-right delay-[100ms]">
              <div className="flex items-center justify-between mb-4">
                <h5 className="text-[10px] font-bold tracking-widest text-[#2d7a26] uppercase">LIVE DASHBOARD</h5>
                <div className="flex items-center gap-1.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2d7a26] animate-pulse"></div>
                  <span className="text-[10px] text-gray-500">Live</span>
                </div>
              </div>
              <div className="flex items-center gap-3 mb-4">
                <Droplet className="w-4 h-4 text-[#1B4889]" />
                <span className="text-xs font-semibold text-gray-600">SOIL MOISTURE</span>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <h3 className="text-4xl font-bold text-[#1a2d1a] leading-none">28%</h3>
                  <p className="text-[10px] text-[#2d7a26] mt-1 font-medium">Optimal Range</p>
                </div>
                {/* Fake line chart CSS */}
                <div className="h-12 w-24 flex items-end gap-1 pb-1">
                  {[40, 30, 20, 35, 25, 28].map((h, i) => (
                    <div key={i} className="w-full bg-[#1B4889]/10 rounded-t-sm" style={{ height: `${h}%` }}>
                      <div className="w-full h-[2px] bg-[#1B4889] mb-[-1px]"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Widget 2: Weather */}
            <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 rounded-2xl p-5 grid grid-cols-2 gap-4 items-center animate-on-scroll-right delay-[200ms]">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <Thermometer className="w-4 h-4 text-orange-500" />
                  <span className="text-[10px] font-semibold text-gray-600 tracking-wider">WEATHER</span>
                </div>
                <h3 className="text-3xl font-bold text-[#1a2d1a] leading-none mb-1">32°C</h3>
                <p className="text-[10px] text-gray-500 font-medium">Partly Cloudy</p>
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex justify-between text-[10px]">
                  <span className="text-gray-500">Humidity</span>
                  <span className="text-[#1a2d1a] font-bold">62%</span>
                </div>
                <div className="flex justify-between text-[10px]">
                  <span className="text-gray-500">Wind</span>
                  <span className="text-[#1a2d1a] font-bold">14 km/h</span>
                </div>
                <div className="flex justify-between text-[10px]">
                  <span className="text-gray-500">Rain (24h)</span>
                  <span className="text-[#1a2d1a] font-bold">0 mm</span>
                </div>
              </div>
            </div>

            {/* Widget 3: Irrigation Status */}
            <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 rounded-2xl p-5 flex justify-between items-center animate-on-scroll-right delay-[300ms]">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <Droplets className="w-4 h-4 text-[#1B4889]" />
                  <span className="text-[10px] font-semibold text-gray-600 tracking-wider">IRRIGATION STATUS</span>
                </div>
                <h3 className="text-3xl font-bold text-[#1a2d1a] leading-none mb-1">87%</h3>
                <p className="text-[10px] text-gray-500 font-medium">Irrigation Complete</p>
              </div>
              {/* Circular Progress */}
              <div className="relative w-16 h-16 flex items-center justify-center shrink-0">
                <svg className="w-full h-full -rotate-90">
                  <circle cx="32" cy="32" r="28" fill="transparent" stroke="rgba(0,0,0,0.05)" strokeWidth="4" />
                  <circle cx="32" cy="32" r="28" fill="transparent" stroke="#2d7a26" strokeWidth="4" strokeDasharray="175" strokeDashoffset="22" className="transition-all duration-1000" />
                </svg>
                <Sprout className="w-5 h-5 text-[#2d7a26] absolute" />
              </div>
            </div>

            {/* Widget 4: Crop Health */}
            <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 rounded-2xl p-5 flex justify-between items-center animate-on-scroll-right delay-[400ms]">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <Leaf className="w-4 h-4 text-[#2d7a26]" />
                  <span className="text-[10px] font-semibold text-gray-600 tracking-wider">CROP HEALTH</span>
                </div>
                <h3 className="text-2xl font-bold text-[#1a2d1a] leading-none mb-1">Good</h3>
                <p className="text-[10px] text-[#2d7a26] font-medium">NDVI 0.72</p>
              </div>
              <div className="w-24 h-16 bg-[#2d7a26]/10 border border-[#2d7a26]/20 rounded-lg overflow-hidden relative">
                <img src={cropHeatmapImg} alt="Crop Health NDVI Heatmap" className="w-full h-full object-cover" />
              </div>
            </div>

            {/* Widget 5: Alerts */}
            <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 rounded-2xl p-5 animate-on-scroll-right delay-[500ms]">
              <div className="flex items-center justify-between mb-4">
                <Bell className="w-3.5 h-3.5 text-gray-500" />
                <span className="text-[9px] font-semibold text-gray-600 tracking-wider">ALERTS & RECOMMENDATIONS</span>
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex items-start gap-2">
                  <CheckCircle2 className="w-3.5 h-3.5 text-[#2d7a26] shrink-0 mt-0.5" />
                  <p className="text-[10px] text-gray-600 font-medium">Irrigation running on Zone 3</p>
                </div>
                <div className="flex items-start gap-2">
                  <AlertTriangle className="w-3.5 h-3.5 text-orange-500 shrink-0 mt-0.5" />
                  <p className="text-[10px] text-gray-600 font-medium">Monitor pest activity in Zone 7</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Divisions Section */}
      <section
        className="py-12 relative overflow-hidden"
        id="divisions"
        style={{
          backgroundImage: `url('${divBg}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          contentVisibility: 'auto'
        }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="flex flex-col gap-3 items-center text-center">
            {/* Top Content */}
            <div className="w-full max-w-4xl mx-auto flex flex-col items-center">
              <div className="animate-on-scroll flex items-center gap-3 bg-primary-green text-white px-5 py-2.5 rounded-full w-fit mb-6 shadow-sm">
                <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                <span className="text-xs font-bold uppercase tracking-widest">Our Divisions</span>
              </div>
              <h2 className="animate-on-scroll delay-[150ms] text-2xl lg:text-4xl font-bold mb-6 leading-[1.1] text-[#1a1a1a]">
                Built Around Every Stage Of Smarter Land Development.
              </h2>
              <p className="animate-on-scroll delay-[300ms] text-[#666666] text-sm lg:text-base mb-4 leading-relaxed font-medium opacity-80 max-w-3xl">
                Whether you are looking for intelligent farming, plant supply, sustainable land development, farm security, eco-spiritual landscapes, or end-to-end ecosystem management — each Kisan division is designed to solve a specific need through specialized expertise and integrated execution.
              </p>
              <p className="animate-on-scroll delay-[450ms] text-[#666666] text-sm lg:text-base mb-8 leading-relaxed font-medium opacity-80 max-w-3xl">
                Explore the division that aligns with your land, vision, or ecosystem goals.
              </p>
            </div>

            {/* Cards Grid */}
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                {
                  path: '/divisions/greenhabitat-360',
                  icon: <HomeIcon className="w-8 h-8" strokeWidth={1.5} />,
                  img: greenhabitatImg,
                  title: 'GreenHabitat 360',
                  desc: 'From Land To Lifestyle. Designed As One Ecosystem.',
                  alt: 'Luxury residential estate with landscaped gardens, swimming pool, and green open spaces showcasing integrated sustainable community design.'
                },
                {
                  path: '/divisions/farm360',
                  icon: <Tractor className="w-8 h-8" strokeWidth={1.5} />,
                  img: farm360Img,
                  title: 'Kisan Farm360',
                  desc: 'From Soil To Yield. Managed By One Partner.',
                  alt: 'Fruit orchard with healthy trees and ripe produce illustrating integrated farm management and sustainable commercial agriculture.'
                },
                {
                  path: '/divisions/plantiq',
                  icon: <Sprout className="w-8 h-8" strokeWidth={1.5} />,
                  img: plantiqImg,
                  title: 'Kisan Plantiq',
                  desc: 'Premium Plant Supply. Rooted In Science.',
                  alt: 'Hands planting a young sapling in fertile soil representing premium plant cultivation and sustainable nursery development.'
                },
                {
                  path: '/divisions/agriq',
                  icon: <Lightbulb className="w-8 h-8" strokeWidth={1.5} />,
                  img: agriQImg,
                  title: 'Kisan Agriq',
                  desc: 'From Soil To Strategy. Smarter Farming Starts Here.',
                  alt: 'Agriculture experts inspecting healthy crops in a field to demonstrate precision farming, crop advisory, and modern farm management.'
                },
                {
                  path: '/divisions/irriq',
                  icon: <Droplets className="w-8 h-8" strokeWidth={1.5} />,
                  img: irriqImg,
                  title: 'Kisan Irriq',
                  desc: 'Precision Water Management For Optimal Growth.',
                  alt: 'Smart irrigation system with solar-powered water management infrastructure supporting efficient and sustainable agricultural irrigation.'
                },
                {
                  path: '/divisions/organiq',
                  icon: <Leaf className="w-8 h-8" strokeWidth={1.5} />,
                  img: organiqImg,
                  title: 'Kisan Organiq',
                  desc: 'Pure. Natural. Sustainable Organic Ecosystems.',
                  alt: 'Hand applying organic fertilizer to a young plant, promoting natural crop nutrition and sustainable organic farming practices.'
                },
                {
                  path: '/divisions/secure',
                  icon: <ShieldCheck className="w-8 h-8" strokeWidth={1.5} />,
                  img: secureImg,
                  title: 'Kisan Secure',
                  desc: 'Complete Land And Farm Security Infrastructure.',
                  alt: 'AI-powered surveillance cameras monitoring agricultural fields for farm security, asset protection, and smart land management.'
                },
                {
                  path: '/divisions/vedvan',
                  icon: <Flower2 className="w-8 h-8" strokeWidth={1.5} />,
                  img: vedvanImg,
                  title: 'Kisan Vedvan',
                  desc: 'Eco-Spiritual Ecosystems. Designed With Purpose.',
                  alt: 'Landscaped eco-park with circular gardens, water feature, and pavilion representing sustainable green spaces and ecological design.'
                }
              ].map((division, i) => (
                <Link to={division.path} key={i} className={`block bg-white rounded-[1.2rem] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.12)] transition-all duration-500 group flex flex-col relative ${i < 4 ? 'animate-on-scroll-left' : 'animate-on-scroll-right'} ${i % 4 === 0 ? '' : i % 4 === 1 ? 'delay-[150ms]' : i % 4 === 2 ? 'delay-[300ms]' : 'delay-[450ms]'}`}>
                  <div className="relative aspect-[1.3/1] w-full overflow-visible">
                    <div className="w-full h-full overflow-hidden">
                      <img
                        src={division.img}
                        alt={division.alt}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-black/20 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out origin-center z-0"></div>
                    </div>
                    
                    {/* Circular Badge */}`n                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg z-10 overflow-hidden">
                      {/* Animated green background from center */}
                      <div className="absolute inset-0 bg-primary-green rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-500 ease-out origin-center"></div>
                      {/* Icon */}
                      <div className="relative z-10 transition-colors duration-500">
                        {division.icon}
                      </div>
                    </div>
                  </div>
                  
                  <div className="px-6 pt-14 pb-8 text-center flex-1 flex flex-col justify-center">
                    <h4 className="text-[1.2rem] font-bold text-primary-green-dark mb-2 leading-tight group-hover:text-primary-green transition-colors duration-300">{division.title}</h4>
                    <p className="text-[0.95rem] text-[#666] font-medium leading-relaxed">{division.desc}</p>
                  </div>
                </Link>
              ))}
            </div>
            
            <div className="animate-on-scroll mt-4">
              <a href="/divisions" className="inline-flex items-center gap-2 px-8 py-3 bg-primary-green text-white rounded-lg font-bold hover:bg-primary-green-dark transition-all shadow-lg hover:shadow-xl">
                Discover Our Divisions
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sustainability Section */}
      <section className="py-20 bg-[#0E1D27]" id="sustainability">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {/* Section Header */}
          <div className="animate-on-scroll flex flex-col items-center text-center mb-16">
            <h2 className="text-3xl lg:text-5xl font-bold mb-1 leading-[1.1] text-white">
              Build Smarter Today. Sustain Better Tomorrow.
            </h2>
          </div>

          {/* Cards Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {[
              {
                icon: <Droplets className="w-7 h-7" strokeWidth={1.5} />,
                title: "Smarter Water Sustainability",
                text: "Intelligent irrigation systems designed to reduce water wastage and improve long-term efficiency.",
                bgImg: irriqImg
              },
              {
                icon: <Leaf className="w-7 h-7" strokeWidth={1.5} />,
                title: "Healthier Soil & Ecosystem Balance",
                text: "Stronger plantations and greener ecosystems built to support long-term ecological health.",
                bgImg: organiqImg
              },
              {
                icon: <MapPin className="w-7 h-7" strokeWidth={1.5} />,
                title: "Responsible Land Development",
                text: "Integrated ecosystem planning designed for sustainable and future-ready land growth.",
                bgImg: greenhabitatImg
              },
              {
                icon: <ShieldCheck className="w-7 h-7" strokeWidth={1.5} />,
                title: "Long-Term Ecosystem Stewardship",
                text: "Continuous monitoring and ecosystem management designed to sustain performance beyond execution.",
                bgImg: sustainability
              }
            ].map((item, index) => (
              <div key={index} className={`relative bg-white p-8 rounded-none border border-primary-green/20 shadow-[0_0_20px_rgba(0,0,0,0.06)] hover:border-primary-green/60 hover:shadow-[0_0_30px_rgba(0,0,0,0.15)] hover:-translate-y-2 transition-all duration-500 group flex flex-col h-[320px] overflow-hidden animate-on-scroll-left ${index === 0 ? '' : index === 1 ? 'delay-[150ms]' : index === 2 ? 'delay-[300ms]' : 'delay-[450ms]'}`}>
                {/* Background Image that fades in on hover */}
                <div className="absolute inset-0 z-0">
                  <img src={item.bgImg} alt={item.title} className="w-full h-full object-cover scale-110 group-hover:scale-100 transition-all duration-700 opacity-0 group-hover:opacity-100" />
                  <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 flex flex-col h-full">
                  <div className="w-14 h-14 bg-primary-green/5 group-hover:bg-primary-green rounded-full flex items-center justify-center text-primary-green group-hover:text-white mb-6 transition-colors duration-500 shadow-sm">
                    {item.icon}
                  </div>
                  <h4 className="text-[1.15rem] font-bold text-primary-green-dark mb-3 leading-snug group-hover:text-white transition-colors duration-500">{item.title}</h4>
                  <p className="text-[#666666] text-[0.95rem] font-medium leading-relaxed group-hover:text-white/90 transition-colors duration-500 flex-1">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center animate-on-scroll">
            <a href="/sustainability" className="inline-flex items-center gap-2 px-10 py-3.5 bg-primary-green text-white rounded-lg font-bold hover:bg-primary-green-dark transition-all shadow-lg hover:shadow-xl">
              Sustainable Ecosystems
            </a>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-12 bg-[#f9fafb]" id="projects">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-10 animate-on-scroll">
            <div className="flex items-center gap-3 bg-primary-green text-white px-5 py-2.5 rounded-full w-fit mb-8 shadow-sm">
              <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
              <span className="text-xs font-bold uppercase tracking-widest">Our Projects</span>
            </div>
            <h2 className="text-2xl lg:text-3xl font-bold leading-[1.1] text-[#1a1a1a] mb-8">
              Built Around Real Land. Real Growth.
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 mb-12">
            {[
              { id: 'harvestsphere', img: proj1, title: 'HarvestSphere', div: 'FARM360 | Hyderabad', desc: 'Smart Farm Management', alt: 'Smart farm estate with orchards, water bodies, and modern infrastructure showcasing integrated Farm360 agricultural management.' },
              { id: 'verdantliving-estates', img: proj2, title: 'VerdantLiving Estates', div: 'GREENHABITAT 360 | Vizag', desc: 'Sustainable Eco Living', alt: 'Sustainable residential estate featuring landscaped gardens, sports courts, and green community spaces promoting eco-friendly living.' },
              { id: 'agrointel-valley', img: proj3, title: 'AgroIntel Valley', div: 'AGRIQ | Khammam', desc: 'Agricultural Development', alt: 'Smart agricultural plantation with tractor, satellite monitoring, and precision farming technologies supporting sustainable crop production.' },
              { id: 'devavanam-retreat', img: proj4, title: 'Devavanam Retreat', div: 'VEDVAN | East Godavari', desc: 'Sacred Green Ecosystem', alt: 'Eco-spiritual retreat with landscaped gardens, walking paths, and native greenery designed for sustainable wellness and nature conservation.' },
            ].map((project, i) => (
              <Link to={`/projects/${project.id}`} key={i} className={`group animate-on-scroll block relative bg-white rounded-[1.2rem] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_15px_40px_rgba(0,0,0,0.12)] transition-all duration-500 hover:-translate-y-2 ${i === 0 ? '' : i === 1 ? 'delay-[150ms]' : i === 2 ? 'delay-[300ms]' : 'delay-[450ms]'}`}>
                <div className="relative aspect-[1.1/1] w-full overflow-hidden">
                  <img src={project.img} alt={project.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500"></div>
                </div>
                <div className="p-5 relative bg-white border-t border-gray-100">
                  {/* Animated top border line */}
                  <div className="absolute top-0 left-0 h-[3px] w-0 bg-primary-green group-hover:w-full transition-all duration-500 ease-out z-10"></div>
                  
                  <h4 className="text-lg font-bold text-[#1a1a1a] group-hover:text-primary-green transition-colors duration-300 mb-1 leading-tight">{project.title}</h4>
                  <p className="text-[10px] font-bold text-primary-green mb-2 tracking-wider uppercase">{project.div}</p>
                  
                  <div className="relative">
                    <p className="text-sm text-[#666666] font-medium transition-opacity duration-300 group-hover:opacity-0">{project.desc}</p>
                    
                    {/* Slide-in View Project link (Overlays the description) */}
                    <div className="absolute top-0 left-0 flex items-center text-primary-green font-bold text-sm transform opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                      View Project <ChevronRight className="w-4 h-4 ml-1" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="flex justify-center mt-12 animate-on-scroll">
            <a href="/projects" className="inline-flex items-center gap-2 px-8 py-3 bg-primary-green text-white rounded-lg font-bold hover:bg-primary-green-dark transition-all shadow-lg hover:shadow-xl">
              View Project Portfolio
            </a>
          </div>
        </div>
      </section>

      {/* Scene 7: Impact at Scale */}
      <section 
        className="relative py-32 bg-[#0a1a0f] overflow-hidden" 
        id="impact"
        style={{
          backgroundImage: `url(${impactMapImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Dark Overlay for Readability */}
        <div className="absolute inset-0 bg-[#0a1a0f]/70 z-0"></div>

        {/* Cinematic Ambient Glows */}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#2d7a26]/50 to-transparent"></div>
        <div className="absolute -top-32 left-1/4 w-[800px] h-[800px] bg-[#2d7a26] rounded-full blur-[150px] opacity-10 pointer-events-none"></div>
        <div className="absolute bottom-10 right-10 w-[500px] h-[500px] bg-emerald-900 rounded-full blur-[120px] opacity-20 pointer-events-none"></div>

        <div className="relative z-10 max-w-[1500px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          {/* LEFT: Impact Headline & Key Numbers */}
          <div className="lg:col-span-3 flex flex-col gap-10">
            <div className="animate-on-scroll-left">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1.5 h-1.5 bg-[#2d7a26] rounded-full animate-pulse"></div>
                <p className="text-[10px] font-bold tracking-[0.25em] text-[#2d7a26] uppercase">Impact At Scale</p>
              </div>
              <h2 className="text-4xl lg:text-5xl font-extrabold text-white mb-6 leading-[1.1] tracking-tight">
                Impact That Can Be Measured.
              </h2>
              <p className="text-[#a0b0a5] text-lg font-medium leading-relaxed">
                Across land, water, plantations and long-term farm operations, our work creates measurable value at scale.
              </p>
            </div>

            <div className="flex flex-col gap-8 border-t border-white/10 pt-8 animate-on-scroll-left delay-[200ms]">
              <div>
                <h3 className="text-3xl font-bold text-white mb-1">20+</h3>
                <p className="text-[11px] font-bold tracking-widest text-[#2d7a26] uppercase">Years of Experience</p>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-white mb-1 flex items-center gap-2">
                  Multi-State <MapPin className="w-5 h-5 text-[#2d7a26]" />
                </h3>
                <p className="text-[11px] font-bold tracking-widest text-[#2d7a26] uppercase">Ecosystem Execution</p>
              </div>
            </div>
            
            <a href="/about" className="animate-on-scroll-left delay-[400ms] w-fit flex items-center gap-2 text-white font-bold hover:text-[#2d7a26] transition-colors group">
              Explore Our Impact <ArrowRight className="w-4 h-4 transform group-hover:translate-x-2 transition-transform" />
            </a>
          </div>

          {/* CENTER: Interactive India Map */}
          <div className="lg:col-span-6 relative flex flex-col items-center justify-center animate-on-scroll-zoom delay-[300ms]">
            <div className="relative w-full max-w-[600px] aspect-[0.9] flex items-center justify-center pointer-events-none">
              
            </div>

            {/* Center Overlay Statement */}
            <div className="absolute bottom-[-2rem] w-full max-w-[400px] text-center bg-[#0a1a0f]/80 backdrop-blur-md border border-white/5 rounded-2xl p-6 shadow-2xl animate-on-scroll delay-[800ms]">
              <p className="text-white text-lg font-medium italic leading-relaxed">
                "Scale is meaningful only when every acre receives the same attention."
              </p>
            </div>
          </div>

          {/* RIGHT: Visual Impact Categories */}
          <div className="lg:col-span-3 flex flex-col gap-4 relative z-20 pt-16 lg:pt-0">
            {[
              { num: "100,000+", label: "Acres Assessed", img: realisticFarmImg, desc: "Satellite map layer", delay: "delay-[100ms]" },
              { num: "10M+", label: "Plants Supplied", img: plantiqImg, desc: "Nursery rows growing", delay: "delay-[250ms]" },
              { num: "150+", label: "Water Systems", img: irriqImg, desc: "Irrigation network lighting up", delay: "delay-[400ms]" },
              { num: "2,500+", label: "Customers Served", img: greenhabitatImg, desc: "Dashboard and field visuals", delay: "delay-[550ms]" }
            ].map((metric, i) => (
              <div key={i} className={`relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 flex items-center gap-5 overflow-hidden group hover:bg-white/10 transition-colors duration-300 animate-on-scroll-right ${metric.delay}`}>
                {/* Visual Imagery Background on Hover */}
                <div className="absolute right-0 top-0 w-1/2 h-full opacity-0 group-hover:opacity-30 transition-opacity duration-700 z-0 mask-image-gradient-left">
                  <img src={metric.img} alt={metric.label} className="w-full h-full object-cover grayscale" />
                </div>
                
                {/* Metric Info */}
                <div className="relative z-10 flex-1">
                  <h4 className="text-3xl font-bold text-white mb-1 group-hover:text-[#2d7a26] transition-colors">{metric.num}</h4>
                  <p className="text-[11px] font-bold tracking-widest text-[#a0b0a5] uppercase">{metric.label}</p>
                </div>
                
                {/* Small indicator icon */}
                <div className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center shrink-0 relative z-10 group-hover:border-[#2d7a26] group-hover:bg-[#2d7a26] transition-all">
                  <ArrowRight className="w-3.5 h-3.5 text-white transform -rotate-45" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 14: New Premium Founder's Section */}
      <section id="founder" className="py-24 bg-gradient-to-br from-[#ffffff] to-[#f0f9f0] relative overflow-hidden animate-on-scroll">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-[#16a34a]/10 to-transparent rounded-full blur-[100px] pointer-events-none translate-x-1/3 -translate-y-1/3"></div>
          
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 relative z-10">
              <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
                  {/* Left Side: Editorial Vision */}
                  <div className="lg:w-1/2 relative animate-on-scroll-right">
                      {/* Massive decorative quote mark */}
                      <div className="absolute -top-16 -left-12 text-[#16a34a]/10 font-serif text-[200px] leading-none select-none pointer-events-none">"</div>
                      
                      <div className="relative z-10">
                          <h2 className="text-3xl md:text-4xl lg:text-[40px] font-black text-slate-900 leading-[1.2] mb-10 tracking-tight">
                              Anyone can plant trees.<br />
                              Building ecosystems that truly last is <span className="text-[#16a34a] bg-[#16a34a]/10 px-2 leading-relaxed inline-block mt-2 transform -skew-x-6">different.</span>
                          </h2>

                          <div className="space-y-6 text-slate-600 text-lg leading-relaxed font-medium mb-12">
                              <p className="border-l-4 border-[#16a34a] pl-6 italic">
                                  "Kisan Plant Technologies was built with a simple belief — agricultural land management and sustainable land use strategies deserve long-term thinking, not short-term execution."
                              </p>
                              <p className="pl-7">
                                  By combining regenerative land management, climate smart land management systems, and a comprehensive farm environmental management plan, we provide solutions to sustainable agriculture that help transform land into ecosystems that grow stronger year after year.
                              </p>
                              <p className="pl-7 text-xl text-[#16a34a] font-black tracking-wide">Because healthy land creates legacy.</p>
                          </div>

                          <div className="pt-8 border-t-2 border-slate-900/5 flex items-center gap-6 pl-7">
                              <div>
                                  <h4 className="text-2xl font-black text-slate-900 tracking-wider">VEERA BHADRA REDDY</h4>
                                  <p className="text-sm font-bold text-[#16a34a] uppercase tracking-[0.2em] mt-2">Founder & CEO</p>
                              </div>
                          </div>
                      </div>
                  </div>

                  {/* Right Side: Framed Portrait */}
                  <div className="lg:w-1/2 relative animate-on-scroll-left">
                      <div className="relative z-10 w-[90%] mx-auto lg:ml-auto lg:mr-0 mt-10 lg:mt-0">
                          {/* Offset Decorative Frame */}
                          <div className="absolute -inset-4 bg-white/50 backdrop-blur-xl border border-white rounded-[2.5rem] shadow-[0_20px_40px_-15px_rgba(0,0,0,0.05)] transform rotate-3 transition-transform duration-700 hover:rotate-1 pointer-events-none"></div>
                          
                          {/* Image Container */}
                          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-[6px] border-white z-10 aspect-[4/5] bg-white group">
                              <img 
                                  
                                  
                                  src={founder} 
                                  alt="Veera Bhadra Reddy - Kisan Plant Founder"
                                  className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-1000" 
                              />
                              
                              {/* Soft Inner Shadow */}
                              <div className="absolute inset-0 shadow-[inset_0_-50px_50px_-20px_rgba(0,0,0,0.3)] pointer-events-none"></div>
                          </div>

                          {/* Floating Glassmorphism Badge */}
                          <div className="absolute -bottom-10 -left-6 lg:-left-16 bg-white/80 backdrop-blur-2xl p-6 md:p-8 rounded-[2rem] shadow-[0_20px_40px_-15px_rgba(22,163,74,0.2)] z-20 border border-white flex items-center gap-6 animate-bounce-slow">
                              <div className="text-5xl md:text-6xl font-black text-[#16a34a] leading-none tracking-tighter">20<span className="text-3xl">+</span></div>
                              <div className="h-12 w-px bg-slate-200"></div>
                              <div className="text-xs md:text-sm font-black text-slate-700 uppercase tracking-widest leading-relaxed">
                                  Years of<br/><span className="text-[#16a34a]">Green Vision</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>

      {/* Scene 9: Knowledge Center */}
      <section className="relative py-24 bg-slate-50 overflow-hidden" id="knowledge">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          {/* Section Header */}
          <div className="animate-on-scroll flex flex-col items-center text-center mb-16">
            <div className="flex items-center gap-3 bg-primary-green text-white px-5 py-2.5 rounded-full w-fit mb-6 shadow-sm">
              <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
              <p className="text-xs font-bold uppercase tracking-widest">Expert Insights</p>
            </div>
            <h2 className="text-3xl lg:text-5xl leading-[1.1] text-[#1a1a1a] font-extrabold mb-4">
              Learn, Don't Just See.
            </h2>
            <p className="text-[#666666] font-medium max-w-2xl text-lg">
              Explore our latest thoughts on agricultural technology, ecosystem stewardship, and the future of sustainable farming.
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {[
              {
                title: "The Future of Smart Irrigation",
                category: "Technology",
                img: insight1,
                desc: "Discover how AI-driven water management is reducing waste by 40% while maximizing crop yields across diverse terrains."
              },
              {
                title: "Why Ecosystem Stewardship Matters",
                category: "Sustainability",
                img: insight2,
                desc: "Beyond planting trees: the long-term economic and environmental benefits of maintaining a holistic farm ecosystem."
              },
              {
                title: "Soil Intelligence",
                category: "Agronomy",
                img: insight3,
                desc: "How real-time soil data and predictive analytics are revolutionizing nutrient application and field health."
              }
            ].map((insight, i) => (
              <div key={i} className={`bg-white rounded-[2rem] overflow-hidden shadow-lg shadow-slate-200/50 border border-slate-100 group hover:-translate-y-2 transition-all duration-500 animate-on-scroll-zoom flex flex-col`}>
                <div className="relative h-60 overflow-hidden">
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                  <img src={insight.img} alt={insight.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute top-5 left-5 z-20 bg-white/95 backdrop-blur-md px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest text-primary-green shadow-sm">
                    {insight.category}
                  </div>
                </div>
                <div className="p-8 flex flex-col flex-1 relative">
                  {/* Decorative corner accent */}
                  <div className="absolute top-0 right-8 w-12 h-1 bg-primary-green/20 rounded-b-full"></div>
                  <h3 className="text-xl lg:text-2xl font-bold text-slate-900 mb-4 group-hover:text-primary-green transition-colors line-clamp-2 leading-snug">
                    {insight.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-8 flex-1 line-clamp-3">
                    {insight.desc}
                  </p>
                  <button className="flex items-center gap-2 text-primary-green font-bold text-sm tracking-widest uppercase group/btn w-fit">
                    Read Article <ArrowRight className="w-4 h-4 transform group-hover/btn:translate-x-1.5 transition-transform" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="flex justify-center animate-on-scroll">
            <Link to="/knowledge/resources" className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 rounded-full font-bold transition-all transform hover:-translate-y-1 shadow-xl flex items-center gap-3">
              <BookOpen className="w-5 h-5" /> Read Full Articles
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-8 animate-on-scroll">
            <div className="flex items-center gap-3 bg-primary-green text-white px-5 py-2.5 rounded-full w-fit mb-6 shadow-sm">
              <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
              <p className="text-xs font-bold uppercase tracking-widest">Client Perspectives</p>
            </div>
            <h2 className="text-2xl lg:text-3xl leading-[1.1] text-[#1a1a1a] font-bold">
              Why Landowners Trust Kisan.
            </h2>
          </div>

          <div className="relative group/slider">
            {/* Navigation Arrows */}
            {canScrollTestiLeft && (
              <button onClick={() => scrollTestimonialDir('prev')}
                className="absolute -left-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/80 backdrop-blur-md rounded-full shadow-xl flex items-center justify-center text-slate-900 hover:bg-primary-green hover:text-white transition-all opacity-100 md:opacity-0 md:group-hover/slider:opacity-100 border border-slate-100">
                <ChevronLeft className="w-6 h-6" />
              </button>
            )}
            {canScrollTestiRight && (
              <button onClick={() => scrollTestimonialDir('next')}
                className="absolute -right-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/80 backdrop-blur-md rounded-full shadow-xl flex items-center justify-center text-slate-900 hover:bg-primary-green hover:text-white transition-all opacity-100 md:opacity-0 md:group-hover/slider:opacity-100 border border-slate-100">
                <ChevronRight className="w-6 h-6" />
              </button>
            )}
            
            <div
              ref={testimonialsRef}
              onScroll={handleTestimonialScroll}
              className="flex items-stretch gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-4 animate-on-scroll"
            >
            {[
              {
                name: 'K Rajamohan Reddy',
                role: 'CMD IBC Ltd, Chennai',
                project: '120 Acres - Mango & Teak Plantation',
                img: client1,
                text: '"We initially planned only teak. Their team explained soil suitability and long-term maintenance properly. Now the plantation is growing much healthier than expected." ',
                alt: 'Customer profile of K. Rajamohan Reddy, CMD of IBC Ltd., Chennai, managing 120-acre mango and teak plantations.'
              },
              {
                name: 'K.S Rao',
                role: 'Businessman, Guntur',
                project: '15 Acres - Guava Plantation',
                img: client2,
                text: '"Most companies just sell plants and disappear. Kisan stayed involved even after plantation. That gave us confidence." ',
                alt: 'Customer profile of K.S. Rao, businessman from Guntur, managing a 15-acre guava plantation.'
              },
              {
                name: 'Sridevi',
                role: 'Mango Farmer, Chittoor',
                project: '30 Acres - Mango Plantation',
                img: client3,
                text: '"Water usage reduced a lot after drip planning. The farm is easier to manage now, especially during summer." ',
                alt: 'Customer profile of Sridevi, mango farmer from Chittoor, managing a 30-acre mango plantation.'
              },
              {
                name: 'UmaMaheswar Rao',
                role: 'Business Owner, Nalgonda',
                project: '25 Acres - Lemon Farming & Other Crops',
                img: client4,
                text: '"Their planning was practical, not just theoretical. Spacing, irrigation, soil checks — everything was clearly guided." ',
                alt: 'Customer profile of UmaMaheswar Rao, business owner from Nalgonda, managing 25 acres of lemon farming and mixed crops.'
              },
              {
                name: 'Dr. Dasari Srinivasulu',
                role: 'IAS, Warangal',
                project: '55 Acres - Guava, Mango & Sapota Farming',
                img: client5,
                text: '"We almost gave up on the land because nothing we planted survived properly. After the soil analysis and irrigation correction, the difference was visible within months." ',
                alt: 'Customer profile of Dr. Dasari Srinivasulu, IAS from Warangal, managing 55 acres of guava, mango, sapota, and mixed farming.'
              },
              {
                name: 'A. Rajasekhar',
                role: 'Sangam, Nellore',
                project: '180 Acres - Amla, Mango, Sandalwood & Red Sandal',
                img: client6,
                text: '"My father believed the land was unlucky because every plantation failed earlier. Today, seeing healthy growth across the farm gives our whole family peace of mind." ',
                alt: 'Customer profile of A. Rajasekhar from Sangam, Nellore, managing 180 acres of amla, mango, sandalwood, and red sandal plantations.'
              },
              {
                name: 'M. Nityananda Reddy',
                role: 'NRI, Moinabad',
                project: 'Greenhabitat House Construction & Land Development',
                img: client7,
                text: '"We live in Hyderabad and couldn\'t monitor the farm regularly. Their team handled everything professionally without us constantly following up." ',
                alt: 'Customer profile of M. Nityananda Reddy, NRI from Moinabad, associated with GreenHabitat house construction and land development.'
              },
              {
                name: 'Srinivasa Rao',
                role: 'Business Owner, Vijayanagaram',
                project: '30 Acres - All Crops',
                img: client8,
                text: '"What we liked most was honesty. They clearly explained what would work on our land and what wouldn\'t — instead of just trying to sell expensive plants." ',
                alt: 'Customer profile of Srinivasa Rao, business owner from Vijayanagaram, managing 30 acres of diversified crop cultivation.'
              },
              {
                name: 'Shaik Badesaheb',
                role: 'Business Owner, Tadipatri',
                project: '10 Acres - Greenhabitat360',
                img: client9,
                text: '"The plantation now feels like a real asset, not abandoned land. Even visitors notice the transformation immediately." ',
                alt: 'Customer profile of Shaik Badesaheb, business owner from Tadipatri, managing 10 acres under the GreenHabitat360 project.'
              },
              {
                name: 'Srinivasa Reddy',
                role: 'Business Owner, Dhone',
                project: '15 Acres - Greenhabitat360',
                img: client10,
                text: '"Earlier our irrigation bills kept increasing but crop quality was still inconsistent. The smart irrigation setup finally brought balance." ',
                alt: 'Customer profile of Srinivasa Reddy, business owner from Dhone, managing 15 acres under the GreenHabitat360 project.'
              }
            ].map((testimonial, i) => (
              <div key={i} className="bg-white p-8 rounded-[1.2rem] border border-gray-100 shadow-sm relative hover:shadow-md transition-all duration-500 h-auto flex flex-col justify-between min-w-[300px] md:min-w-[350px] max-w-[350px] snap-center shrink-0">
                <div>
                  <div className="flex gap-1 text-[#fbbf24] mb-4">
                    {[1, 2, 3, 4, 5].map((s) => <Star key={s} className="w-3.5 h-3.5 fill-current" />)}
                  </div>
                  <p className="text-sm lg:text-[15px] text-[#1e293b] font-medium leading-relaxed mb-6 italic opacity-90">
                    {testimonial.text}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-gray-100 overflow-hidden shrink-0">
                    <img src={testimonial.img} alt={testimonial.alt} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-primary-green leading-tight mb-0.5">{testimonial.name}</h4>
                    <p className="text-[#64748b] text-[11px] uppercase tracking-wider font-bold mb-0.5">{testimonial.role}</p>
                    {testimonial.project && (
                      <p className="text-primary-green text-[11px] font-bold flex items-center gap-1 mt-1">
                        <ShieldCheck className="w-3.5 h-3.5" />
                        {testimonial.project}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-8 animate-on-scroll">
            {Array.from({ length: 10 }).map((_, idx) => (
              <button
                key={idx}
                onClick={() => scrollToTestimonial(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${activeTestimonial === idx
                    ? 'bg-primary-green w-6'
                    : 'bg-gray-200 hover:bg-primary-green/50'
                  }`}
                aria-label={`Go to testimonial ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Contact Banner Section */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div
            className="rounded-[3rem] overflow-hidden relative min-h-[260px] flex items-center shadow-2xl"
            style={{
              backgroundColor: '#2d8a39',
              backgroundImage: `linear-gradient(rgba(51, 145, 68, 0.7), rgba(51, 145, 68, 0.7)), url(${hero2})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="container relative z-10 px-8 lg:px-16 py-12 grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-0 items-start">
              {/* General Enquiries */}
              <div className="flex flex-col items-start lg:border-r border-white/30 lg:pr-12 h-full">
                <div className="flex items-center gap-2 text-white mb-4">
                  <Mail className="w-5 h-5" />
                  <h4 className="text-lg">General enquiries</h4>
                </div>
                <div className="space-y-1">
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=info@kisanplant.technology"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-base font-medium hover:underline"
                  >
                    info@kisanplant.technology
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex flex-col items-start lg:border-r border-white/30 lg:px-12 h-full">
                <div className="flex items-center gap-2 text-white mb-4">
                  <Headset className="w-5 h-5" />
                  <h4 className="text-lg">Give us a call</h4>
                </div>
                <div className="space-y-1">
                  <a href="tel:+919492023333" className="text-white text-base font-medium hover:underline">
                    +91 9492023333
                  </a>
                </div>
              </div>

              {/* Location */}
              <div className="flex flex-col items-start lg:pl-12 h-full">
                <div className="flex items-center gap-2 text-white mb-4">
                  <MapPin className="w-5 h-5" />
                  <h4 className="text-lg">Contact Location</h4>
                </div>
                <p className="text-white text-base font-medium leading-relaxed max-w-[280px]">
                  Kisan Plant Technologies Pvt. Ltd.,
                  Plot no 11 Sneha Residency,
                  Behind kalyani motors, LB Nagar, Hyderabad-500068
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
